export default __webpack_public_path__ + "static/media/19.f7ad0e50.gif";